export {
	useRoomsRecommendedForYou,
	useRoomsRecommendedForYouAudience,
} from './use-rooms-recommended-for-you';
export type { RoomsRecommendedForYouVariables } from './use-rooms-recommended-for-you';
